import { render, staticRenderFns } from "./RoleCapabilitiesTable.vue?vue&type=template&id=1d9de842&scoped=true&"
import script from "./RoleCapabilitiesTable.vue?vue&type=script&lang=js&"
export * from "./RoleCapabilitiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9de842",
  null
  
)

export default component.exports